import * as t from 'io-ts';

export const GraphRateSide = t.keyof({ LENDER: null, BORROWER: null });

export type GraphRateSide = t.TypeOf<typeof GraphRateSide>;
